<template>
<div class="immolisting__wrapper savedsearch">
  <div class="wp-block-columns immolisting__header">
    <div class="wp-block-column">
      <span class="fal fa-home"></span>
      <title-field :category="category" :marketingType="item.marketingType"></title-field>
    </div>

    <div class="wp-block-column">
      <span class="fas fa-edit" @click="edit" :title="$t('Bearbeiten')"></span>
      <span class="fas fa-trash" @click="remove" :title="$t('Löschen')"></span>
    </div>
  </div>

  <div class="savedsearch__content">
    <h3>
      <price-field type="text" :field="findField('price.value')" format="currency"></price-field>
    </h3>

    <div class="immolisting__wrapper">
      <ul class="savedsearch__facts">
        <li v-if="location && location.radius"><location-field :field="location"></location-field></li>
        <li><range-field :label="label('property[baujahr]')" :field="findField('property[baujahr]')" icon="fas fa-hammer"></range-field></li>
      </ul>

      <ul class="immolisting__iconfields">
        <li v-for="(f, k) in areaFields" :key="k">
          <icon-field :icon="icon(f.name)" :label="label(f.name)" :field="findField(f.name)"></icon-field>
        </li>
      </ul>
    </div>
  </div>
</div>
</template>

<script>
import PriceField from "./fields/PriceField";
import LocationField from "./fields/LocationField";
import RangeField from "./fields/RangeField";
import TitleField from "./fields/TitleField";
import IconField from "./fields/IconField";

export default {
  name: "SavedSearch",

  components: {
    PriceField,
    LocationField,
    RangeField,
    TitleField,
    IconField
  },

  props: [
    "fieldsConfig",
    "categoryList",
    "item"
  ],

  data() {
    return {
      iconFields: () => []
    }
  },

  computed: {
    category() {
      let category = null;

      this.categoryList.forEach(c => {
        if (c.id == this.item.categoryId) {
          category = c;
        }
      });

      return category;
    },

    location() {
      if (!this.item.locations || this.item.locations.length == 0) {
        return null;
      }

      return this.item.locations[0];
    },

    areaFields() {
      const list = [];
      this.item.fields.forEach(f => {
        const fc = this.fieldConfig(f.name);
        if (fc && fc.group == "area") {
          list.push(f);
        }
      });

      return list;
    }
  },

  methods: {
    remove() {
      this.$emit("remove", this.item);
    },

    edit() {
      this.$emit("edit", this.item);
    },

    icon(n) {
      const f = this.fieldConfig(n);

      if (f) {
        return f.icon;
      }

      return "";
    },

    findField(n) {
      if (this.item.fields) {
        return this.item.fields.find(f => {
          return f.name == n;
        });
      }

      return null;
    },

    fieldConfig(n) {
      if (!this.fieldsConfig) {
        return null;
      }

      const f = this.fieldsConfig.find(v => {
        return v.id == n;
      });

      return f;
    },

    label(n) {
      const f = this.fieldConfig(n);

      if (f) {
        return f.label;
      }

      return "";
    }
  }
};
</script>
